import useNavModel, { RouterParamType } from '@/model/navModel'
import { Button, DatePicker, message, Table } from 'antd'
import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { vehicleDetialModel } from './vehicleDetialModel'
import dayjs from 'dayjs'
import Print from './Print'
import { imgCustomerLists, imgTeamLists, orderStatusEnum, orderTypeEnum } from '@/types/AppEnums'
import OrderLogs from './orderLogs'
import ImgModal from './imgModal'
import { orderService } from '../../orderService'
import { RangePickerProps } from 'antd/lib/date-picker'
import { DetialModal } from './detialModel'

// eslint-disable-next-line react-hooks/rules-of-hooks
export const SystemOrderDetails = () => {
    const { getSelectedNavState } = useNavModel(({ selectedNavId }) => [selectedNavId])
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType)
    useEffect(() => {
        if (!detailsInfo?.id) return
        setVehicleSearchParam({})
        getOne(initPgCfg, {}, detailsInfo.id)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [detailsInfo])
    const { RangePicker } = DatePicker
    const {
        initPgCfg,
        getOne,
        pgCfg,
        vehicleSearchParam,
        setVehicleSearchParam,
        detailLookList,
        selectedRowKeys,
        setSelectedRowKeys,
        SelectedId,
        setSelectedId,
        setPrint,
        setPrintStatus,
        showLogs,
        setShowLogs,
        vehicleFormVal,
        setVehicleFormVal,
        imgLookData,
        setImgLookData,
        exportData,
        setImageClassifyList,
        setDetialVisible,
    } = vehicleDetialModel()
    // eslint-disable-next-line arrow-body-style
    const disabledDate: RangePickerProps['disabledDate'] = (current) => {
        // Can not select days before today and today
        return current && current > dayjs().endOf('day')
    }
    //不同条件检索
    const seach = (value) => {
        let obj: any = {}
        if (value === 'week') {
            let time = new Date().getTime()
            let endTime = time - 7 * 24 * 3600 * 1000
            obj.startTime = dayjs(endTime).format('YYYY-MM-DDT00:00:00')
            obj.endTime = dayjs(time).format('YYYY-MM-DDT23:59:59')
        } else if (value === 'month') {
            let Nowdate = new Date()
            let nowMonth = Nowdate.getMonth() // 当前月
            let nowYear = Nowdate.getFullYear() // 当前年
            let time = new Date().getTime() // 当前时间
            let monthStartDate = new Date(nowYear, nowMonth, 1) // 本月的开始时间
            obj.startTime = dayjs(monthStartDate).format('YYYY-MM-DDT00:00:00')
            obj.endTime = dayjs(time).format('YYYY-MM-DDT23:59:59')
        } else if (value === 'year') {
            let Nowdate = new Date()
            let nowYear = Nowdate.getFullYear() // 当前年
            let yearStartDate = new Date(nowYear, 0, 1) // 本年的开始时间
            let time = new Date().getTime() // 当前时间
            obj.startTime = dayjs(yearStartDate).format('YYYY-MM-DDT00:00:00')
            obj.endTime = dayjs(time).format('YYYY-MM-DDT23:59:59')
        }
        setVehicleSearchParam(obj)
        getOne(initPgCfg, obj, detailsInfo.id)
    }
    //点击行选高亮
    const onRow = (record: any) => {
        setVehicleFormVal(record)
    }
    const lookLog = (record: any) => {
        setShowLogs(true)
        setSelectedId(record.id)
    }
    const detialOne = (record: any) => {
        setDetialVisible(true)
        setSelectedId(record.id)
    }
    const handleLookImg = (str, id) => {
        let list = str === 'customer' ? imgCustomerLists : imgTeamLists
        let imageClassifyList = list.sort(function (a, b) {
            return b.required - a.required
        })
        setImageClassifyList(imageClassifyList)
        let data: any = {
            imageGroup: str,
            pageNum: 1,
            pageSize: 100,
            id: id,
            // id:"c604ad81d1484a54a54781de5c726326",
        }
        orderService
            .getImageClassifyList(data)
            .then((res: any) => {
                let imageList: any = []
                if (res.retData.records.length === 0) {
                    message.warning('本条工单并无照片显示')
                } else {
                    imageClassifyList.forEach((item: any) => {
                        let images: any = res.retData.records.filter((i) => i.attachmentType === item.imageCode)
                        let fileList: any = []
                        if (images.length > 0) {
                            item.file = images.map((ele) => {
                                const { attachmentMd5: MD5 } = ele
                                const url: any = `https://file-server.yunhaochefu.com/image/${MD5}`
                                imageList.push(url)
                                fileList.push({
                                    uid: MD5,
                                    id: ele.id,
                                    status: 'done',
                                    url,
                                    isHas: true,
                                })
                                return {
                                    url,
                                    MD5,
                                    ...ele,
                                }
                            })
                        }
                        item.fileList = fileList
                    })
                    setImageClassifyList([...imageClassifyList])
                    setImgLookData({ visible: true, repairMode: str, id: id })
                }
            })
            .catch((error) => {
                console.log('error: ', error)
            })
    }

    const columns: any = [
        {
            title: '序号',
            width: 60,
            fixed: 'left',
            render: (t, r, i) => i + 1,
        },
        {
            title: '操作',
            width: 140,
            fixed: 'left',
            align: 'center',
            render: (text, record, index) => (
                <div style={{ display: 'flex' }}>
                    <Button type="primary" shape="round" onClick={() => handleLookImg('customer', record.id)}>
                        故障照片
                    </Button>
                    <Button type="primary" shape="round" onClick={() => handleLookImg('team', record.id)}>
                        现场照片
                    </Button>
                </div>
            ),
        },
        {
            title: '工单编号',
            width: 160,
            dataIndex: 'orderCode',
            align: 'center',
            render: (text, record) => (
                <span style={{ color: '#4062d8', cursor: 'pointer' }} onClick={() => detialOne(record)}>
                    {text}
                </span>
            ),
        },
        {
            title: '工单类型',
            width: 100,
            dataIndex: 'orderType',
            align: 'center',
            render: (t, r, i) => orderTypeEnum[t],
        },
        {
            title: '服务地点',
            width: 160,
            dataIndex: 'repairAddress',
            align: 'center',
            // render: (text) => <YhTootip text={text} style={{ width: '160px' }} />,
        },
        {
            title: '登记日期',
            width: 140,
            dataIndex: 'createTime',
            align: 'center',
            // render: (text) => <YhTootip text={text} style={{ width: '140px' }} />,
        },
        {
            title: '完工日期',
            width: 140,
            dataIndex: 'orderCompletedTime',
            align: 'center',
            // render: (text) => <YhTootip text={text} style={{ width: '140px' }} />,
        },
        {
            title: '故障描述',
            width: 160,
            dataIndex: 'faultDesc',
            align: 'center',
            // render: (text) => <YhTootip text={text} style={{ width: '160px' }} />,
        },
        {
            title: '维修团队',
            width: 160,
            dataIndex: 'teamName',
            align: 'center',
            // render: (text) => <YhTootip text={text} style={{ width: '160px' }} />,
        },
        {
            title: '处理结果',
            width: 160,
            dataIndex: 'processResult',
            align: 'center',
            // render: (text) => <YhTootip text={text} style={{ width: '160px' }} />,
        },
        {
            title: '总金额',
            width: 100,
            dataIndex: 'orderActualAmount',
            align: 'center',
        },
        {
            title: '日志',
            width: 160,
            dataIndex: 'suffixNum',
            align: 'center',
            render: (text, record, index) => (
                <span style={{ color: '#4165E3', cursor: 'pointer' }} onClick={() => lookLog(record)}>
                    查看日志
                </span>
            ),
        },
        {
            title: '审核人',
            width: 100,
            dataIndex: 'reviewerName',
            align: 'center',
        },
        {
            title: '工单状态',
            width: 100,
            dataIndex: 'orderStatus',
            align: 'center',
            render: (t, r, i) => orderStatusEnum[t],
        },
        {
            title: '备注',
            width: 160,
            dataIndex: 'remark',
            align: 'center',
            // render: (text) => <YhTootip text={text} style={{ width: '160px' }} />,
        },
    ]

    return (
        <>
            <div style={{ backgroundColor: '#fff', height: 'calc(100vh - 110px)', minHeight: '500px' }}>
                <div style={{ display: 'flex', padding: '20px', alignItems: 'center' }}>
                    工单日期：
                    <RangePicker
                        size="small"
                        style={{ width: '300px' }}
                        format="YYYY-MM-DD"
                        onChange={(value, timeStr) => {
                            let obj =
                                timeStr[0] !== '' && timeStr[1] !== ''
                                    ? {
                                          startTime: timeStr[0] + 'T00:00:00',
                                          endTime: timeStr[1] + 'T23:59:59',
                                      }
                                    : {}
                            setVehicleSearchParam(obj)
                            getOne(initPgCfg, obj, detailsInfo.id)
                        }}
                        disabledDate={disabledDate}
                        value={
                            vehicleSearchParam && vehicleSearchParam.startTime && vehicleSearchParam.endTime
                                ? [moment(vehicleSearchParam.startTime), moment(vehicleSearchParam.endTime)]
                                : undefined
                        }
                    />
                    <span style={{ color: '#2596ff', cursor: 'pointer', margin: '0 10px 0 30px' }} onClick={() => seach('week')}>
                        最近7天
                    </span>
                    <span style={{ color: '#2596ff', cursor: 'pointer', margin: '0 10px' }} onClick={() => seach('month')}>
                        查询当月
                    </span>
                    <span style={{ color: '#2596ff', cursor: 'pointer', margin: '0 10px' }} onClick={() => seach('year')}>
                        查询当年
                    </span>
                </div>
                <hr style={{ border: 'none', height: '1px', backgroundColor: '#ccc', margin: '3px 10px' }} />
                <div style={{ margin: '10px', border: '1px dashed rgba(24, 144, 255, 1)', backgroundColor: 'rgba(24, 144, 255,0.12)' }}>
                    <span style={{ margin: '20px', lineHeight: '40px' }}>
                        您好，<span style={{ color: 'rgba(24,144,255,1)' }}>{vehicleFormVal.customerVehicleCode}</span> 于
                        <span style={{ color: 'rgba(24,144,255,1)' }}>{vehicleFormVal.createTime}</span> 在我平台登记维保服务，由我司
                        <span style={{ color: 'rgba(24,144,255,1)' }}>
                            {vehicleFormVal.ciOrderUsers?.map((item, index) => {
                                return index === 0 ? item.userName : '，' + item.userName
                            })}
                            [主修人]
                        </span>
                        在<span style={{ color: 'rgba(24,144,255,1)' }}>{vehicleFormVal.orderCompletedTime}</span> 完成服务。感谢您的支持，祝您生活愉快。
                    </span>
                </div>
                <hr style={{ border: 'none', height: '1px', backgroundColor: '#ccc', margin: '3px 10px' }} />
                <Button
                    className="m-15"
                    shape="round"
                    type="primary"
                    onClick={() => {
                        setPrint(true)
                        setPrintStatus('inDetial')
                    }}
                >
                    打印
                </Button>
                <Button className="m-15" shape="round" type="primary" onClick={() => exportData()}>
                    导出
                </Button>
                <Table
                    rowKey={(record) => record.id}
                    rowSelection={{
                        //全部选中时 (存row[])
                        onSelectAll: (selected, selectedRows, changeRows) => {
                            selected
                                ? setSelectedRowKeys((origin) => [...origin, ...changeRows])
                                : setSelectedRowKeys((origin) => {
                                      let changeRowId = changeRows.map((item) => item.id)
                                      return origin.filter((item) => changeRowId.indexOf(item.id) < 0)
                                  })
                        },
                        onSelect: (record, selected, selectedRows) => {
                            let findObj = selectedRowKeys.find((item) => item.id === record.id)
                            if (findObj) {
                                let newSelectedRowKeys = selectedRowKeys.filter((item) => item.id !== record.id)
                                setSelectedRowKeys(newSelectedRowKeys)
                            } else {
                                setSelectedRowKeys((origin) => [...origin, record])
                            }
                        },
                        selectedRowKeys: selectedRowKeys.map((item) => item.id),
                    }}
                    columns={columns}
                    scroll={{ x: 'max-content', y: 'calc(100vh - 460px)' }}
                    dataSource={detailLookList}
                    pagination={{
                        ...pgCfg,
                        position: ['bottomRight'],
                        showTotal: () => `共${pgCfg.total}条`,
                        onChange: (pageNum, pageSize) => {
                            getOne({ pageNum, pageSize }, vehicleSearchParam, detailsInfo.id)
                        },
                        showSizeChanger: true,
                    }}
                    bordered
                    onRow={(record) => ({
                        onClick: () => onRow(record),
                        onContextMenu: (e) => {
                            e.preventDefault()
                            setSelectedRowKeys([record])
                        },
                    })}
                    style={{ margin: '0 10px' }}
                />
            </div>
            <Print />
            <OrderLogs orderId={SelectedId} visible={showLogs} setShowLogs={setShowLogs} />
            <ImgModal modalData={imgLookData} setModalData={setImgLookData} orderId={imgLookData && imgLookData.id} />
            <DetialModal />
        </>
    )
}
